import React, { useState } from 'react';
import { Facebook, Instagram, Linkedin, Send, Youtube } from 'lucide-react';
import { BRANDS } from '../../data/brands';
const SERVICES = ['Servis vozil BMW in MINI', 'Servis vozil Jaguar in Land Rover', 'Kleparsko ličarska popravila BMW', 'Prodaja vozil BMW', 'Prodaja vozil Land Rover', 'Prodaja rabljenih vozil'];
const COMPANY = ['O nas', 'Salon', 'Aktualno', 'Zaposlitev'];
const CONTACTS = [['BMW Ljubljana', 'info@wallismotor.si'], ['MINI Ljubljana', 'mini@wallismotor.si'], ['Land Rover Ljubljana', 'landrover@wallismotor.si'], ['BMW Trzin', 'info@avto-aktiv.si'], ['Suzuki Trzin', 'info@avto-aktiv.si'], ['BMW Kranj', 'bmw@avto-aktiv.si'], ['BMW Koper', 'koper@avto-aktiv.si'], ['Opel Koper', 'opel@avto-aktiv.si'], ['BMW Nova Gorica', 'info.ng@avto-aktiv.si'], ['Toyota Nova Gorica', 'info.ng@avto-aktiv.si']];
const SOCIALS = [{
  label: 'Facebook',
  Icon: Facebook
}, {
  label: 'Instagram',
  Icon: Instagram
}, {
  label: 'YouTube',
  Icon: Youtube
}, {
  label: 'LinkedIn',
  Icon: Linkedin
}];
export function Footer() {
  const [submitted, setSubmitted] = useState(false);
  return <footer className="w-full bg-aw-navy-dark text-white" data-id="element-74" data-mp="2p54kkfylrz5q">
      <div className="mx-auto w-full max-w-[1360px] px-5 py-14 lg:px-10" data-id="element-75" data-mp="2bd7vkks8e5dk">
        <div className="flex flex-wrap items-center justify-between gap-6 border-b border-white/10 pb-8" data-id="element-76" data-mp="2gb9mfrvwf8zl">
          <span className="font-heading text-2xl tracking-tight" data-id="element-77" data-mp="340khcsqki95t">
            Auto<span className="font-bold" data-id="element-78" data-mp="33z9dyu11b3f8">Wallis</span>
          </span>
          <ul className="flex items-center gap-3" data-id="element-79" data-mp="3825pk0s5pz9o">
            {SOCIALS.map(({
            label,
            Icon
          }) => <li key={label} data-id="element-80" data-mp="2u2eikk025j56">
                <a href="#" aria-label={label} className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 transition-colors hover:bg-aw-accent" data-id="element-81" data-mp="2z20sajgogh98">
                  <Icon className="h-4 w-4" data-id="element-82" data-mp="1nn4050p75bxn" />
                </a>
              </li>)}
          </ul>
        </div>

        <div className="grid gap-10 py-12 md:grid-cols-3" data-id="element-83" data-mp="13k7vib05wxni">
          <FooterCol title="Blagovne znamke" items={BRANDS.map(b => b.name)} data-id="element-84" data-mp="zimc06t4hl4c" />
          <FooterCol title="Storitve" items={SERVICES} data-id="element-85" data-mp="usfo696fq4n5" />
          <FooterCol title="AutoWallis" items={COMPANY} data-id="element-86" data-mp="uquvkp3okvrx" />
        </div>

        <div className="grid gap-12 border-t border-white/10 pt-12 lg:grid-cols-[1fr_1.4fr]" data-id="element-87" data-mp="pu4dxxc89s4e">
          <div data-id="element-88" data-mp="kui1hq484fwn">
            <h3 className="mb-5 text-sm font-bold uppercase tracking-[0.1em]" data-id="element-89" data-mp="kv18wcw8zlwf">Hitri kontakt</h3>
            <ul className="space-y-2.5 text-sm" data-id="element-90" data-mp="fu3v0ci9te0q">
              {CONTACTS.map(([place, mail]) => <li key={place + mail} className="flex flex-wrap gap-x-4 text-white/60" data-id="element-91" data-mp="buctpev4bfhy">
                  <span className="min-w-[170px] font-medium text-white/85" data-id="element-92" data-mp="6vidmkojc51j">{place}</span>
                  <a href={`mailto:${mail}`} className="hover:text-aw-accent" data-id="element-93" data-mp="267ujz9mwqqgo">
                    {mail}
                  </a>
                </li>)}
            </ul>
          </div>

          <div data-id="element-94" data-mp="28siqevos1rdl">
            <h3 className="mb-3 text-sm font-bold uppercase tracking-[0.1em]" data-id="element-95" data-mp="28qzetie2g4i5">
              Ne zamudite naših e-novic in bodite obveščeni
            </h3>
            <p className="mb-6 max-w-xl text-sm leading-relaxed text-white/60" data-id="element-96" data-mp="2ihtxkcs3slyu">
              Koristne vsebine in obvestila o dogodkih pošiljamo enkrat do štirikrat mesečno,
              nanašajo pa se na posebne ugodnosti, ki jih lahko izkoristite, dogodke in druge
              koristne vsebine s področja avtomobilizma.
            </p>
            <form className="space-y-4" onSubmit={e => {
            e.preventDefault();
            setSubmitted(true);
          }} data-id="element-97" data-mp="1utaq1zgvod7t">
              <div className="grid gap-4 sm:grid-cols-2" data-id="element-98" data-mp="23t654fdk0sd4">
                <label className="block" data-id="element-99" data-mp="23ql4ftozsigy">
                  <span className="sr-only" data-id="element-100" data-mp="3b5g1jm58tsm8">Vaše ime</span>
                  <input required type="text" placeholder="Vaše ime *" className="w-full rounded-sm border border-white/20 bg-white/5 px-4 py-3 text-sm text-white placeholder:text-white/45 focus:border-aw-accent focus:outline-none focus:ring-1 focus:ring-aw-accent" data-id="element-101" data-mp="3f82y20cv01pr" />
                </label>
                <label className="block" data-id="element-102" data-mp="3nmqtlz79jom8">
                  <span className="sr-only" data-id="element-103" data-mp="3ipqy2i81i49d">Elektronski naslov</span>
                  <input required type="email" placeholder="Elektronski naslov *" className="w-full rounded-sm border border-white/20 bg-white/5 px-4 py-3 text-sm text-white placeholder:text-white/45 focus:border-aw-accent focus:outline-none focus:ring-1 focus:ring-aw-accent" data-id="element-104" data-mp="kdxiue9esvv" />
                </label>
              </div>
              <div className="flex flex-wrap items-start gap-5" data-id="element-105" data-mp="jadlfdyd61xp">
                <label className="flex max-w-xl flex-1 items-start gap-3 text-[11px] leading-relaxed text-white/55" data-id="element-106" data-mp="j8ixrrvpjvpx">
                  <input required type="checkbox" className="mt-0.5 h-4 w-4 shrink-0 rounded-sm border-white/30 bg-transparent" data-id="element-107" data-mp="xxu1pkhk08ab" />
                  <span data-id="element-108" data-mp="ox5vvd2bde8i">
                    S klikom na gumb Prijava na e-novice dovoljujete, da vas obveščamo o novicah,
                    dogodkih in posebnih akcijah ter izrecno soglašate z obdelavo osebnih podatkov
                    za namene pošiljanja novic.
                  </span>
                </label>
                <button type="submit" className="inline-flex items-center gap-2 bg-white px-6 py-3 text-sm font-semibold text-aw-navy transition-colors hover:bg-aw-accent hover:text-white" data-id="element-109" data-mp="jy2vw716xy7e">
                  <Send className="h-4 w-4" data-id="element-110" data-mp="a5x2qtz7daqm" />
                  {submitted ? 'Hvala za prijavo' : 'Prijavite se'}
                </button>
              </div>
              {submitted && <p role="status" className="text-sm text-aw-accent" data-id="element-111" data-mp="16jqjtjp2827">
                  Uspešno ste prijavljeni na e-novice.
                </p>}
            </form>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10" data-id="element-112" data-mp="1y3xt83zemu9o">
        <div className="mx-auto flex w-full max-w-[1360px] flex-wrap justify-between gap-3 px-5 py-5 text-[11px] text-white/45 lg:px-10" data-id="element-113" data-mp="1u58kiopba0wd">
          <span data-id="element-114" data-mp="1p2zo1id8cgpi">© 2026 Vse pravice pridržane AutoWallis</span>
          <span data-id="element-115" data-mp="2lubpk6p0vfa2">Politika zasebnosti | Made by Epic people</span>
        </div>
      </div>
    </footer>;
}
function FooterCol({
  title,
  items
}: {
  title: string;
  items: string[];
}) {
  return <div data-id="element-116" data-mp="2ctvkissms033">
      <h3 className="mb-5 text-sm font-bold uppercase tracking-[0.1em]" data-id="element-117" data-mp="2ctdiffjaern9">{title}</h3>
      <ul className="space-y-2.5 text-sm text-white/60" data-id="element-118" data-mp="27wdat06shgu1">
        {items.map(item => <li key={item} data-id="element-119" data-mp="11g1d107vq0yz">
            <a href="#" className="hover:text-aw-accent" data-id="element-120" data-mp="11gb0oh5gbw1i">
              {item}
            </a>
          </li>)}
      </ul>
    </div>;
}